module.exports = __webpack_public_path__ + "img/go-support.64e56fba.png";